
export const StoreLogger = store => {
  store.subscribe((mutation, state) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`%c# %c${mutation.type}`, 'font-weight: bold; color:red;', 'font-weight:bold; color:gray', mutation.payload)
    }
  })
}



// WEBPACK FOOTER //
// ./src/stores/plugins/store-logger.plugin.js